/**
 * set Cookie function
 * @param {string} name
 * @param {*} value
 * @param {number} exp
 */
const setCookie = (name, value, exp) => {
    const i = new Date();
    i.setTime(i.getTime() + 24 * exp * 60 * 60 * 1e3);
    let n = "expires=" + i.toUTCString();
    document.cookie = name + "=" + value + ";" + n + ";path=/";
};

/**
 * get cookie function
 * @param {string} cname
 * @returns
 */
const getCookie = (cname) => {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == " ") {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
};

/**
 * document ready function
 * @param {*} callBack
 */
const ready = (callBack) => {
    document.readyState === "loading"
        ? // The document is still loading
          document.addEventListener("DOMContentLoaded", function (e) {
              callBack();
          })
        : // The document is loaded completely
          callBack();
};

/**
 * custom Scroll to function
 * @param {string} selector
 * @param {number} yOffset
 */
const customScrollTo = (selector, yOffset = 0) => {
    const el = document.querySelector(selector);
    const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;
    window.scrollTo({ top: y, behavior: "smooth" });
};

const htmlCssMin = (input) => {
    return input
        .replace(/\>[\r\n ]+\</g, "><")
        .replace(/(<.*?>)|\s+/g, (m, $1) => ($1 ? $1 : " "))
        .trim()
        .replace(/\}[\r\n ]+/g, "}")
        .replace(/[\r\n ]+{/g, "{")
        .replace(/{\s+|\s+}/g, (m) => m.trim());
};

export { setCookie, getCookie, ready, customScrollTo, htmlCssMin };
